.text-shadow {
  text-shadow: 1px 1px 6px rgba(46, 61, 73, 0.9);
}

.cristal-text-shadow {
  text-shadow: 1px 1px 3px rgba(46, 61, 73, 0.075);
}

.landing-cadastro-subtitle {
  margin-left: 16px;
  font-style: italic;
  text-wrap: wrap;
}

.center-title {
  text-align: center;
  font-size: 30px;
  padding: 0px 36px;
  margin: 16px 0px;
  width: 80vw;
  max-width: 600px;
}

.block-container {
  min-width: 100%;
  height: auto;
}

.block {
  display: inline-block;
  position: relative;
  overflow: visible;
  /* padding-bottom: 48px; */
  min-height: 20vh;
  height: auto;
  height: auto;
}

/* Landing */
.top-row-pad {
  padding-right: calc(8% - 8px);
}

.landing-container {
  /* background-color: #6200EE; */
  /* background-image: url('/assets/img/landing-bg.jpg'); */
  background-image: linear-gradient(to bottom righ  t, rgb(237, 238, 248), rgb(210, 210, 210));
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 36px 0px 36px 0px;
  box-shadow: 2px 4px 10px 6px rgba(46, 61, 73, 0.3);
}

.landing-inner-container {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100vw;
  max-width: calc(240px + 72vw);
}

.landing-block {
  width: 80vw;
  margin-top: 28px;
  margin-bottom: 28px;
}

.landing-block-1 {
  max-width: 600px !important;
  margin-right: 48px;
}

.landing-title {
  font-size: 56px;
  padding: 0px;
  margin: 0px;
}

@media only screen and (min-width: 500px) and (max-width: 800px) {
  .landing-title {
    font-size: 36px;
  }
  .landing-block-1 {
    margin-right: 0px !important;
  }
}

@media only screen and (max-width: 500px) {
  .landing-inner-container {
  }
  .landing-title {
    font-size: 32px;
  }
  .landing-block-1 {
    margin-right: 0px !important;
  }
}

.landing-sub-title {
  /* color: rgba(255, 255, 255, 0.78); */
  font-size: 28px;
  margin-bottom: 0px;
  font-weight: 500;
}

.landing-list {
  /* color: rgba(255, 255, 255, 0.78); */
  font-size: 22px;
  margin-bottom: 0px;
}

.landing-sub-title-2 {
  margin-bottom: 8px !important;
}

.landing-buttons {
  display: inline-flex;
  min-width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 8px;
}

.landing-button {
  /* display: inline; */
  position: relative;
  /* padding-right: 12px; */
  flex-grow: 1 !important;
  width: 80vw;
}

.landing-button-1 {
  min-width: 56% !important;
  max-width: 266px;
  padding-right: 12px;
}

.landing-button-2 {
  min-width: 35% !important;
  width: 80vw !important;
  max-width: 200px;
}

.landing-button-3 {
  min-width: 35% !important;
  max-width: 200px;
}

.landing-button-4 {
  min-width: 40% !important;
  max-width: 250px;
}

@media only screen and (max-width: 600px) {
  .landing-button {
    padding-bottom: 8px;
  }

  .landing-button-1 {
    max-width: 80vw;
    padding-right: 0px;
  }

  .landing-button-2 {
    max-width: 80vw;
  }

  .landing-button-3 {
    max-width: 80vw;
  }

  .landing-button-4 {
    max-width: 80vw;
  }
}

/* .landing-button-btn button-native {
  width: 100%;
} */

.landing-img-icon {
  width: 20%;
  max-width: 100px;
}
.landing-store-icon {
  width: 100%;
  height: 100%;
}

.landing-store-icon-link {
  width: 65%;
  max-width: 260px;
}

.landing-signup-form {
  padding: 0px 18px;
}

.landing-block-2 {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  min-width: 20vw !important;
  width: 424px !important;
  max-width: 620px !important;
}
@media only screen and (max-width: 500px)  {
  .landing-block-2 {
    width: 95vw !important;
    max-width: 95vw !important;
  }
  .landing-signup-form {
    padding: 0px;
  }
}
@media only screen and (min-width: 500px) and (max-width: 1200px)   {
  .landing-block-2 {
    width: 90vw !important;
    max-width: 540px !important;
  }
}

.landing-flipper {
  /* display: inline-f; */
  max-height: 400px;
  max-width: 276px !important;
}

.landing-flipper-image {
  object-fit: contain;
  position: relative;
  width: 80vw;
  max-width: 276px !important;
  height: 100%;
  max-height: 400px;
  min-height: 400px;
}

/* .st-flippy {
  display: inline-block !important;
  position: relative;
  height: auto;
  max-width: 380px;
} */

.st-flippy__back {
  position: relative !important;
}

/* Landing */

.slideshow-container {
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding-top: 48px;
  padding-bottom: 24px;
}

.slideshow-block {
  position: relative;
  width: 90vw;
  max-width: 860px;
  height: auto;
}

.slideshow-constraints {
  /* max-height: 556px !important; */
}

.slide-box {
  max-height: 100%;
  /* padding-bottom: 25%; */
}

.slider-slide {
  /* min-height: 100% !important;
  max-height: 100% !important; */
}

.slideshow-inner-block {
  position: relative;
  width: 100%;
  height: auto;
}

.slideshow-slider-container {
  position: relative;
  display: inline-block;
  width: 100%;
  height: auto;
  padding: 0px 28px;
}

.slideshow-slider {
  position: relative;
  display: inline-block;
  width: 100%;
  /* margin: 0px 28px; */
  max-height: 528px;
}

.slideshow-controls {
  box-sizing: content-box;
  pointer-events: none;
  width: 100%;
  /* calc(100% + 56px); */
  height: 100%;
  /* left: -28px; */
  display: inline-flex;
  position: absolute;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

.slideshow-control {
  pointer-events: auto;
}

.slideshow-control-left {
  /* transform: translateX(-28px); */
}

.slideshow-control-right {
  /* transform: translateX(28px); */
}

.slide-text {
  position: relative;
  display: inline-block;
  text-align: center;
  font-size: 20px;
}

@media only screen and (max-width: 900px) and (min-width: 700px) {
  .slide-text {
    font-size: 18px !important;
  }
}

@media only screen and (max-width: 700px) and (min-width: 600px) {
  .slide-text {
    font-size: 17px !important;
  }
}

@media only screen and (max-width: 600px) and (min-width: 500px) {
  .slide-text {
    font-size: 16px !important;
  }
}

@media only screen and (max-width: 500px) {
  .slide-text {
    font-size: 15px !important;
  }
}

.slide-image {
  object-fit: contain;
  position: relative;
  display: inline-block;
}

.slide-1-text {
  margin: 10px 0px 30px 0px;
}

.slide-1-image {
  /* width: 70vw !important; */
  max-width: 100% !important;
  max-height: 440px !important;
  padding: 0px 5%;
  /* max-height: 80% !important; */
}

.slide-1-image-over {
  opacity: 0;
  position: absolute !important;
  top: 0px;
  left: 0px;
  z-index: 5;

  transition: ease-in-out;
  transition-duration: 1000ms !important;
  transition-property: "opacity";
}

.slide-1-image-over-anim {
  opacity: 1 !important;

  transition: ease-in-out;
  transition-duration: 1000ms !important;
  transition-property: "opacity";
}

.slide-2-box {
  position: relative;
  display: inline-block;
  height: 54vw;
  max-height: 570px;
}

.slide-2-text {
}

.slide-2-images {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 75% !important;
  /* flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center; */
}

.slide-2-layer-2 {
  display: inline-flex;
  position: relative;
  min-width: 100%;
  height: 100% !important;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 5vmin 5vmin;
  z-index: 2;
}

/* @media only screen and (min-height: 550px) {
  .slide-2-layer-2 {
    font-size: 18px;
  }
} */

.slide-2-image {
  display: inline-block !important;
  position: relative !important;
  left: 0px;
  top: 0px;
}

.slide-2-tablet {
  /* transform: translateX(-5vw); */
  width: 36% !important;
  max-width: 36% !important;
}

.slide-2-phone {
  padding: 3vmin 0vmin 3vmin 4vmin;
  /* transform: translateX(-1vw); */
  width: 24% !important;
  max-width: 24% !important;
}

.slide-2-sms {
  left: 12%;
  width: 9vmin !important;
  opacity: 1;
}

.slide-2-layer-1 {
  display: inline-flex;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  z-index: 0;
}

.slide-2-image-animation {
  display: inline-block !important;
  position: relative;
  text-align: left;
  width: 100% !important;
}

.slide-2-sms-anim {
  left: 78% !important;
  opacity: 0 !important;

  transition: ease-in-out;
  transition-duration: 1700ms !important;
  transition-property: "left, opacity";
}

.slide-3-box {
  position: relative;
  display: inline-flex;
  height: 54vw;
  max-height: 570px;
  padding-bottom: 5%;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  /* margin: 1vh 0vw 5vh 5vw; */
}

.slide-3-text {
  position: relative;
  display: inline-block;
  text-align: justify;
  padding-right: 10%;
}

.slide-3-image-animation {
  display: inline-flex !important;
  position: relative !important;
  min-width: 60%;
  max-width: 60%;
  min-height: 100%;
  overflow: hidden;
}

@media only screen and (max-width: 500px) {
  .slide-3-image-animation {
    min-width: 40%;
    max-width: 40%;
  }
}

@media only screen and (max-width: 600px) and (min-width: 500px) {
  .slide-3-text {
    font-size: 16px !important;
  }
}

@media only screen and (max-width: 500px) {
  .slide-3-text {
    font-size: 14px !important;
  }
}

.slide-3-image {
  display: inline-block !important;
  position: absolute !important;
  left: 0px;
  top: 0px;
  padding: 5%;
  min-width: 100% !important;

  opacity: 0;
  max-width: 30% !important;
  transition: ease-in;
  transition-duration: 800ms !important;
  transition-delay: 200ms !important;
  transition-property: "opacity";
  z-index: 1;
}

.slide-3-image-animated {
  z-index: 2 !important;
  opacity: 1 !important;
  transition: ease-out;
  transition-duration: 600ms !important;
  transition-property: "opacity";
}

.slide-4-box {
  position: relative;
  display: inline-flex;
  height: 54vw;
  max-height: 570px;
  padding-bottom: 5%;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  /* margin: 1vh 0vw 5vh 5vw; */
}

.slide-4-text {
  position: relative;
  display: inline-block;
  text-align: justify;
  padding-left: 10%;
  padding-right: 5%;
}

.slide-4-image-animation {
  display: inline-flex !important;
  position: relative !important;
  min-width: 38%;
  max-width: 38%;
  margin-right: 10%;
  min-height: 70%;
  overflow: hidden;
  box-shadow: 8px 8px 2vw 0 rgba(46, 61, 73, 0.3);
}

@media only screen and (max-width: 600px) and (min-width: 500px) {
  .slide-4-text {
    font-size: 16px !important;
  }
}

@media only screen and (max-width: 500px) {
  .slide-4-text {
    font-size: 14px !important;
  }
}

.slide-4-image {
  display: inline-block !important;
  position: absolute !important;
  object-fit: fill !important;
  left: 0px;
  top: 0px;
  padding: 1px;
  min-width: 100% !important;

  opacity: 0;
  max-width: 30% !important;
  transition: ease-in;
  transition-duration: 800ms !important;
  transition-property: "opacity";
  z-index: 1;
}

.slide-4-image-animated {
  opacity: 1 !important;
  z-index: 2;
  transition: ease-out;
  transition-duration: 800ms !important;
  transition-property: "opacity";
}

.slide-5-box {
  position: relative;
  display: inline-flex;
  height: 54vw;
  max-height: 570px;
  padding-bottom: 5%;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  /* margin: 1vh 0vw 5vh 5vw; */
}

.slide-5-text {
  position: relative;
  display: inline-block;
  text-align: justify;
  padding: 0px 5% 0px 10%;
}

.slide-5-image {
  display: inline-block !important;
  position: relative !important;
  /* left: 0px;
  top: 0px; */
  padding: 0% 10% 0% 0%;
  min-width: 70% !important;

  max-width: 30% !important;
  transition: ease-in;
  transition-duration: 800ms !important;
  transition-property: "opacity";
  z-index: 1;
}
